(function(){
  var legacyCollectionRedirects={
    '/collections/new-arrivals':'/collections/all?sort_by=created-descending',
    '/collections/preets-picks':'/collections/best-sellers',
    '/collections/bourbon-whiskey':'/collections/bourbon',
    '/collections/extra-anejo-tequila':'/collections/extra-anejo',
    '/collections/additive-free':'/collections/tequila/additive-free',
    '/collections/tequila-gifts':'/collections/tequila/gift',
    '/collections/whiskey-gifts':'/collections/whiskey/gift',
    '/collections/champagne':'/collections/wine/champagne',
    '/collections/red-wine':'/collections/wine/red-wine',
    '/collections/white-wine':'/collections/wine/white-wine',
    '/collections/rose':'/collections/wine/rose-wine',
    '/collections/sparkling-wine':'/collections/wine/sparkling'
  };
  var legacyTarget=legacyCollectionRedirects[window.location.pathname.replace(/\/$/,'')];
  if(legacyTarget){window.location.replace(legacyTarget+window.location.hash);return;}
  function initHeader(scope){
    var root=(scope||document);
    var drawer=document.querySelector('[data-preet-search-drawer]');
    if(!drawer || drawer.dataset.preetReady==='true') return;
    drawer.dataset.preetReady='true';
    var openers=document.querySelectorAll('[data-preet-search-open]');
    var closers=drawer.querySelectorAll('[data-preet-search-close]');
    var input=drawer.querySelector('[data-preet-search-input]');
    var items=Array.prototype.slice.call(drawer.querySelectorAll('[data-preet-search-item]'));
    var status=drawer.querySelector('[data-preet-search-status]');
    var empty=drawer.querySelector('[data-preet-search-empty]');
    var closeTimer;
    var lastFocused=null;

    function openSearch(event){
      if(event) event.preventDefault();
      window.clearTimeout(closeTimer);
      lastFocused=document.activeElement;
      drawer.hidden=false;
      drawer.setAttribute('aria-hidden','false');
      openers.forEach(function(button){button.setAttribute('aria-expanded','true');});
      document.body.classList.remove('drawer-open');
      requestAnimationFrame(function(){drawer.classList.add('is-open');document.body.classList.add('preet-search-open');});
      window.setTimeout(function(){if(input) input.focus();},240);
    }
    function closeSearch(){
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden','true');
      openers.forEach(function(button){button.setAttribute('aria-expanded','false');});
      document.body.classList.remove('preet-search-open');
      closeTimer=window.setTimeout(function(){if(!drawer.classList.contains('is-open')) drawer.hidden=true;},700);
      if(lastFocused && typeof lastFocused.focus==='function') lastFocused.focus();
    }
    function filterResults(){
      var raw=input ? input.value.trim() : '';
      var query=raw.toLowerCase();
      var shown=0;
      items.forEach(function(item){
        var searchable=(item.getAttribute('data-search')||'').toLowerCase();
        var match=!query || searchable.indexOf(query)!==-1;
        item.hidden=!match;
        if(match) shown+=1;
      });
      if(status) status.textContent=query ? shown+' result'+(shown===1?'':'s')+' for “'+raw+'”' : 'Popular right now';
      if(empty) empty.hidden=shown>0;
    }

    openers.forEach(function(button){button.addEventListener('click',openSearch);});
    closers.forEach(function(button){button.addEventListener('click',closeSearch);});
    if(input) input.addEventListener('input',filterResults);
    document.addEventListener('keydown',function(event){
      if(event.key==='Escape' && drawer.classList.contains('is-open')) closeSearch();
      if((event.metaKey||event.ctrlKey) && event.key.toLowerCase()==='k'){event.preventDefault();openSearch(event);}
    });
    drawer.addEventListener('keydown',function(event){
      if(event.key!=='Tab') return;
      var focusable=Array.prototype.slice.call(drawer.querySelectorAll('button:not([disabled]),a[href],input:not([disabled])')).filter(function(el){return !el.hidden && el.offsetParent!==null;});
      if(!focusable.length) return;
      var first=focusable[0],last=focusable[focusable.length-1];
      if(event.shiftKey && document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first.focus();}
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){initHeader(document);}); else initHeader(document);
  document.addEventListener('shopify:section:load',function(event){initHeader(event.target);});
})();

/* Preet welcome: 15 seconds per visit, at least one hour between appearances. */
(function () {
  'use strict';
  var editorPreview = !!(window.Shopify && window.Shopify.designMode);
  if (window.__preetWelcomeLoaded) return;
  window.__preetWelcomeLoaded = true;
  var preview = editorPreview || new URLSearchParams(location.search).get('preet_welcome_preview') === '1';
  var animationURL = 'https://cdn.shopify.com/s/files/1/0830/6058/8863/files/preets-wave-clean.gif?v=1790605119';
  var preloadedAnimation = new Image(); preloadedAnimation.src = animationURL;
  var key = 'preet-chat-welcome-last-shown-v2';
  var cooldown = 60 * 60 * 1000;
  function eligible() { try { return Date.now() - Number(localStorage.getItem(key) || 0) >= cooldown; } catch (e) { return true; } }
  var state = { elapsed: 0, done: false };
  var running = false, wrap = null, portrait = null, timer = null, watched = null, observer = null;
  var last = performance.now(), wasVisible = !document.hidden, pending = [];
  function save() {}
  function recordShown() { if (!preview) { try { localStorage.setItem(key, String(Date.now())); } catch (e) {} } }
  function parts() {
    var host = document.querySelector('shopify-chat');
    var runtime = host && host.shadowRoot && host.shadowRoot.querySelector('shopify-agent-runtime');
    var root = (runtime && runtime.shadowRoot) || (host && host.shadowRoot);
    return { host: host, button: root && root.querySelector('[part="activator"]') };
  }
  function isOpen(p) { return !!(p.host && (p.host.hasAttribute('open') || (p.button && p.button.getAttribute('aria-expanded') === 'true'))); }
  function later(fn, delay) { var id = setTimeout(fn, delay); pending.push(id); return id; }
  function cleanup() {
    pending.forEach(clearTimeout); pending = [];
    if (portrait) { portrait.onload = portrait.onerror = null; portrait.removeAttribute('src'); portrait = null; }
    if (wrap) { wrap.remove(); wrap = null; }
    running = false;
    window.removeEventListener('resize', position);
  }
  function dismiss() { state.done = true; save(); cleanup(); if (!preview) clearInterval(timer); }
  function position() {
    var p = parts(); if (!wrap || !p.button) return;
    var r = p.button.getBoundingClientRect();
    var size = Math.min(128, r.width - 12, innerWidth - 24, Math.max(80, r.top - 16));
    wrap.style.width = size + 'px'; wrap.style.height = size + 'px';
    wrap.style.left = Math.max(12, Math.min(innerWidth - size - 12, r.left + (r.width - size) / 2)) + 'px';
    wrap.style.bottom = (innerHeight - r.top - 4) + 'px';
  }
  function openChat() {
    cleanup();
    var p = parts();
    if (!document.hidden && p.button && !isOpen(p)) p.button.click();
  }

  function start() {
    var p = parts();
    if (running || document.hidden || !p.button || isOpen(p) || (!preview && !eligible())) return;
    var rect = p.button.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    state.done = true; recordShown(); running = true;
    wrap = document.createElement('div');
    wrap.id = 'preet-chat-welcome'; wrap.setAttribute('role', 'region'); wrap.setAttribute('aria-label', 'Preet Liquor welcome');
    wrap.style.cssText = 'position:fixed;z-index:2147482999;overflow:hidden;pointer-events:none;';
    var card = document.createElement('div');
    card.style.cssText = 'position:relative;width:100%;height:100%;transform:translateY(105%);transition:transform 550ms ease;pointer-events:auto;';
    portrait = document.createElement('img'); portrait.alt = 'Preet waving hello';
    portrait.style.cssText = 'display:block;width:100%;height:100%;object-fit:contain;cursor:pointer;';
    portrait.setAttribute('role', 'button'); portrait.setAttribute('tabindex', '0'); portrait.setAttribute('aria-label', 'Chat with Preet Liquor');
    portrait.addEventListener('click', openChat);
    portrait.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openChat(); } });
    var close = document.createElement('button');
    close.type = 'button'; close.setAttribute('aria-label', 'Dismiss welcome'); close.textContent = '×';
    close.style.cssText = 'position:absolute;top:4px;right:4px;width:28px;height:28px;padding:0;border:0;border-radius:50%;background:#1a1410;color:#fff;font:22px/28px sans-serif;cursor:pointer;';
    close.addEventListener('click', dismiss);
    card.appendChild(portrait); card.appendChild(close); wrap.appendChild(card); document.body.appendChild(wrap);
    position(); window.addEventListener('resize', position);
    var ending = false;
    function finish() {
      if (!running || ending) return; ending = true;
      card.style.transform = 'translateY(105%)'; later(dismiss, 580);
    }
    portrait.onload = function () {
      if (!running) return;
      if (document.hidden || isOpen(parts())) { dismiss(); return; }
      card.getBoundingClientRect(); card.style.transform = 'translateY(0)';
      if (!editorPreview) later(finish, 5030);
    };
    portrait.onerror = finish;
    if (!editorPreview) later(finish, 12000);
    portrait.src = animationURL;
  }
  function observe(p) {
    if (!p.host || p.host === watched) return;
    if (observer) observer.disconnect(); watched = p.host;
    observer = new MutationObserver(function () { if (isOpen(parts())) dismiss(); });
    observer.observe(p.host, { attributes: true, attributeFilter: ['open'] });
    if (p.button) p.button.addEventListener('click', dismiss);
  }
  function tick() {
    var now = performance.now();
    if (wasVisible && !document.hidden && !state.done) state.elapsed += Math.min(now - last, 2000);
    last = now; wasVisible = !document.hidden;
    var p = parts(); observe(p);
    if (isOpen(p)) { dismiss(); return; }
    if (!preview && !state.done) { save(); if (state.elapsed >= 15000 && !document.hidden) start(); }
  }
  function init() {
    if (state.done && !preview) return;
    if (preview) {
      var test = document.createElement('button'); test.type = 'button'; test.textContent = 'Preview welcome animation';
      test.style.cssText = 'position:fixed;left:16px;bottom:16px;z-index:2147482998;padding:12px 18px;background:#e8b86d;color:#1a1410;border:1px solid #1a1410;border-radius:8px;cursor:pointer;';
      test.addEventListener('click', function () { if (!isOpen(parts())) start(); });
      document.body.appendChild(test);
    }
    timer = setInterval(tick, 1000); tick();
    document.addEventListener('visibilitychange', function () { tick(); if (document.hidden && running) dismiss(); });
    window.addEventListener('pagehide', function () { save(); if (running) cleanup(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && running) dismiss(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();

/* Preet chat: community wording for the existing account sign-in control. */
(function () {
  if (window.__preetCommunityLabel) return;
  window.__preetCommunityLabel = true;
  var watched = new WeakSet();
  function update() {
    var chat = document.querySelector('shopify-chat');
    var runtime = chat && chat.shadowRoot && chat.shadowRoot.querySelector('shopify-agent-runtime');
    var root = (runtime && runtime.shadowRoot) || (chat && chat.shadowRoot);
    if (!root) return;
    var activator = root.querySelector('[part="activator"]');
    var activatorLabel = activator && activator.querySelector('.activator__label');
    if (activatorLabel && activatorLabel.textContent !== 'Ask us anything') activatorLabel.textContent = 'Ask us anything';
    if (activator && activator.getAttribute('aria-label') !== 'Ask us anything. Open chat') activator.setAttribute('aria-label', 'Ask us anything. Open chat');
    var host = root.querySelector('shopify-sign-in-button.panel__sign-in');
    var buttonRoot = host && host.shadowRoot;
    if (!buttonRoot) return;
    var button = buttonRoot.querySelector('button.sign-in-button');
    if (button && /^(Sign in|Join our community)$/i.test(button.textContent.trim())) {
      if (button.textContent !== 'Join our community') button.textContent = 'Join our community';
      if (button.getAttribute('aria-label') !== 'Join our community') button.setAttribute('aria-label', 'Join our community');
    }
    [root, buttonRoot].forEach(function (scope) {
      if (watched.has(scope)) return;
      watched.add(scope);
      new MutationObserver(update).observe(scope, { childList: true, subtree: true, characterData: true });
    });
  }
  update();
  var timer = setInterval(function () { if (!document.hidden) update(); }, 1500);
  window.addEventListener('pagehide', function () { clearInterval(timer); });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) { update(); timer = setInterval(function () { if (!document.hidden) update(); }, 1500); }
  });
})();
